import React from 'react';
import GeneralAutocompleteFilter, { ConcreteAutocompleteFilterProps } from "./GeneralAutocompleteFilter";

const TownsFilter: React.FC<ConcreteAutocompleteFilterProps> = props => {
    return (
        <GeneralAutocompleteFilter
            multiple
            name={ props.name || 'towns' }
            label={ props.label || 'Miejscowości' }
            onFilterChange={ props.onFilterChange }
            options={ props.options }
            values={ props.values }
        />
    );
}
export default TownsFilter;